'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.sliders = twentyninetimes.sliders || function () {

	function init() {
		var sliders = document.querySelectorAll('.js-slider');

		if ( sliders.length > 0 ) {
			sliderFunction(sliders);
		}
	}

	function sliderFunction(sliders) {
		sliders.forEach( (slider) => {
			var type = slider.getAttribute('data-slider-type');

			if ( type == 'media' ) {
				var flky = new Flickity( slider, {
				    accessibility: true,
				    cellSelector: '.slider-item',
				    cellAlign: 'center',
				    freeScroll: false,
				    percentPosition: true,
				    prevNextButtons: true,
				    pageDots: false,
						wrapAround: true,
						adaptiveHeight: true,
				    on: {
				        ready: function() {
				            this.resize();
				        },
				        select: function() {
				        	// remove classes
				        	changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
				        	changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
				        	// set slides
				        	this.previousSlide = this.slides[ this.selectedIndex - 1 ];
				        	this.nextSlide = this.slides[ this.selectedIndex + 1 ];
				        	// add classes
				        	changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
				        	changeSlideClasses( this.nextSlide, 'add', 'is-next' );
				        },
				        staticClick: function( event, pointer, cellElement, cellIndex ) {
						  if ( typeof cellIndex == 'number' ) {
						    this.selectCell( cellIndex );
						  }
						}
				        // change: function() {
				        // 	this.reposition();
				        // }
				    }
				});

			} else {
			    var flky = new Flickity( slider, {
			        accessibility: true,
			        cellSelector: '.slider-item',
			        cellAlign: 'left',
			        contain: true,
			        percentPosition: false,
			        prevNextButtons: true,
			        pageDots: false,
			        arrowShape: '',
			        on: {
			            ready: function() {
			                //this.resize();
			            }
			        }
			    });
			}
		});

		function changeSlideClasses( slide, method, className ) {
		  if ( !slide ) {
		    return;
		  }
		  slide.getCellElements().forEach( function( cellElem ) {
		    cellElem.classList[ method ]( className );
		  });
		}
	}

	return {
		init : init
	};

}();